export const SCHOOLSHUB_SYSTEM_ADMIN_QUERY_PARAMETER = 'system-admin';
const SCHOOLSHUB_SYSTEM_ADMIN_SESSION_STORAGE_KEY = 'schoolshub-system-admin-login';

const hasSchoolshubSystemAdminLoginMarker = (searchParams) =>
    'true' === searchParams.get(SCHOOLSHUB_SYSTEM_ADMIN_QUERY_PARAMETER);

export const rememberSchoolshubSystemAdminLogin = (searchParams, sessionStorage) => {
    if (!hasSchoolshubSystemAdminLoginMarker(searchParams)) {
        return;
    }

    try {
        sessionStorage.setItem(SCHOOLSHUB_SYSTEM_ADMIN_SESSION_STORAGE_KEY, 'true');
    } catch {
        // The explicit query parameter still allows the current login when browser storage is unavailable.
    }
};

export const isSchoolshubSystemAdminLogin = (searchParams, sessionStorage) => {
    if (hasSchoolshubSystemAdminLoginMarker(searchParams)) {
        return true;
    }

    try {
        return 'true' === sessionStorage.getItem(SCHOOLSHUB_SYSTEM_ADMIN_SESSION_STORAGE_KEY);
    } catch {
        return false;
    }
};
